/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React from 'react';

const WiseAvatar = ({
  userName,
  image,
  icon = 'user',
  hideButtonIcon = false,
  country
}) => {
  return (
    <div className="wise-avatar-style">
      {!userName && !country ? (
        <>
          <Flex
            alignItems="center"
            justifyContent="center"
            className="wise-add-user rounded-circle overflow-hidden mh-100 mw-100 w-100 h-100"
          >
            <FontAwesomeIcon icon={icon} />
          </Flex>
          {!hideButtonIcon && (
            <div className="wise-avatar-icon">
              <FontAwesomeIcon icon="plus" size="xs" />
            </div>
          )}
        </>
      ) : (
        <>
          <Flex
            alignItems="center"
            justifyContent="center"
            className="wise-add-user rounded-circle overflow-hidden mh-100 mw-100 w-100 h-100"
          >
            {image ? (
              <img src={image} alt="" className="img-fluid" />
            ) : (
              <span className="fw-bold fs-1">
                {userName.match(/\b\w/g).join('')}
              </span>
            )}
          </Flex>
          {!hideButtonIcon && (
            <div className="wise-avatar-icon border-0 border-white">
              <img
                src={country}
                alt=""
                className="img-fluid"
                style={{
                  height: '16px',
                  width: '16px',
                  transform: 'scale(1.5)'
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WiseAvatar;
